// extracted by mini-css-extract-plugin
export default {"ldsDualRing":"styles_ldsDualRing__+E7GN"};